import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';

type ViewSellerInfoProps = {
    value: string;
    canEdit: boolean;
    onEdit: () => void;
    tooltipEdit: string;
};

export function ViewSellerInfo({ value, canEdit, onEdit, tooltipEdit }: ViewSellerInfoProps) {
    return (
        <dd>
            <Box sx={{ display: 'flex' }}>
                <Typography variant="body1" sx={{ alignSelf: 'center', paddingRight: '8px' }}>
                    {value}
                </Typography>
                {canEdit ? (
                    <Tooltip title={tooltipEdit}>
                        <IconButton
                            aria-label="Edit"
                            size="small"
                            onClick={() => {
                                onEdit();
                            }}
                        >
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                ) : null}
            </Box>
        </dd>
    );
}
